import type { PropsWithChildren } from 'react'

const RightContentContainer = ({ children }: PropsWithChildren) => {
  return (
    <div className="mx-auto flex w-full max-w-none flex-col gap-4 pb-32 md:w-[calc(100vw-350px-32px-20px)] md:max-w-[calc(100vw-350px-32px-20px)] md:pb-10 lg:w-[calc(100vw-500px-60px)] lg:max-w-[calc(1300px-500px-60px)] lg:gap-8">
      {children}
    </div>
  )
}

export default RightContentContainer
